export default __webpack_public_path__ + "static/media/37.d449c778.png";